define('tableDateFieldView',[
  'module', 
  'dateUtils',
  'tableFieldView'
], function (
  Module,
  DateUtils,
  FieldView
) {
  'use strict';

  Module.exports = FieldView.extend({
    className: 'table-field-date-view table-field-view',

    onRender: function() {
      if(this.options.field.bind && this.model.get(this.options.field.bind) )         
        this.$el.html(DateUtils.toDateFormatString(this.model.get(this.options.field.bind)));            
    }
  });
});
